<template>
  <div class="mt-3 links-wrapper">
    <a target="_blank" href="https://guide.partners.house/keitaro">
      <img :src="require('@/assets/images/monetization/keitaro.svg')" alt="keitaro logo" height="22px" />
      <span> {{ $t("platform.arbitrage.keitaro") }} </span>
      <svg v-svg class="ml-2" symbol="arrow" size="0 0 17 17" role="info"></svg>
    </a>
    <a target="_blank" href="https://guide.partners.house/binom">
      <img :src="require(`@/assets/images/monetization/${isDarkTheme ? 'binom-d.png' : 'binom.webp'}`)" alt="binom logo" height="41px" />
      <span>{{ $t("platform.arbitrage.binom") }}</span>
      <svg v-svg class="ml-2" symbol="arrow" size="0 0 17 17" role="info"></svg>
    </a>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "GuideLinks",
  computed: {
    ...mapGetters({
      isDarkTheme: "user/isDarkTheme",
    }),
  },
};
</script>

<style lang="scss" scoped>
.links-wrapper {
  display: flex;
  flex-direction: column;
  gap: 15px 0;
  width: 100%;

  img {
    width: 125px;
  }

  a {
    width: inherit;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 66px;
    gap: 0 4px;
    padding: 12px 26px;
    border: 1px solid #d9d9d9;
    border-radius: 10px;
    svg {
      fill: #626262;
    }
  }

  @media (max-width: 576px) {
    img {
      width: auto;
    }

    a {
      padding: 8px;
    }
  }
}
</style>
